import { numberToPrettyString } from '@cian/utils';
import { NBSP } from 'shared/constants/text';

import { noBreak } from './noBreak';

/** Число с разделителем тысяч, дробная часть через запятую, если не ноль. Как `render_decimal` монолита */
export const formatDecimal = (value: number): string => numberToPrettyString(value);

/** Площадь: `287 000 м²`. В монолите — `str(Decimal)` без форматирования, решение пользователя — форматируем */
export const formatArea = (value: number): string => `${noBreak(formatDecimal(value))}${NBSP}м²`;
